module.exports = __webpack_public_path__ + "static/media/circle-close.a10a3665.svg";